// gyökér layout — minden route ennek a gyermeke
// itt élnek a globális providerek (i18n, TanStack Query client, toaster, theme) — lásd @/app/providers
import { Outlet, createRootRoute } from '@tanstack/react-router';

import { AppProviders } from '@/app/providers';

export const Route = createRootRoute({
  component: RootLayout,
});

function RootLayout(): JSX.Element {
  return (
    <AppProviders>
      <Outlet />
    </AppProviders>
  );
}
